import React from 'react'
import { useSelector } from 'react-redux'

import DashboardWrapper from './DashboardWrapper'

import DashboardFilter from './components/DashboardFilter'
import GroupWrapper from './components/GroupWrapper'

import OverviewCharts from './charts/overview'
import MonthlyCharts from './charts/monthly'
import QuarterlyCharts from './charts/quarterly'

import OverviewTables from './tables/overview'
import MonthlyTables from './tables/monthly'

import ChartsExport from './charts/ChartsExport'
import TablesExport from './tables/TablesExport'

import Flex from '../../../components/layouts/Flex'

const Dashboard = () => {
  const download = useSelector((state) => state.dashboard.download)

  return (
    <DashboardWrapper>
      <div>
        <GroupWrapper title="Report Filters">
          <Flex
            direction="column"
            padding="0 1rem 1rem 0"
            width="100%"
            gap="1rem"
            height="28vh"
            justify="center"
            items="center"
          >
            <DashboardFilter />
          </Flex>
        </GroupWrapper>
      </div>
      <div className="report-container">
        <OverviewCharts />
        <MonthlyCharts />
        <QuarterlyCharts />
        <OverviewTables />
        <MonthlyTables />
      </div>

      {download === 'pdf' && <ChartsExport />}

      {download === 'csv' && <TablesExport />}
    </DashboardWrapper>
  )
}

export default Dashboard
